import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["children"];

var _templateObject;

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import AccordionContext from './AccordionContext';
export var Content = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  ", "\n"])), function (_ref) {
  var hidden = _ref.hidden;
  return hidden && "\n    display: block; /* sanitize sets [hidden] to display: none */\n    height: 0;\n    overflow: hidden;\n    visibility: hidden;\n  ";
});
export default function AccordionContent(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded);

  var _useContext = useContext(AccordionContext),
      expanded = _useContext.expanded,
      id = _useContext.id;

  return /*#__PURE__*/React.createElement(Content, _extends({}, props, {
    id: id,
    hidden: !expanded
  }), children);
}
AccordionContent.propTypes = {
  children: PropTypes.node.isRequired
};